import { c as _c } from "react/compiler-runtime";
import { ApiWaveParticipationRequirement } from "@/generated/models/ApiWaveParticipationRequirement";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import { CreateWaveDropsConfig, CreateWaveDropsRequiredMetadata } from "@/types/waves.types";
import CreateWaveDropsMetadata from "./metadata/CreateWaveDropsMetadata";
import CreateWaveDropsTypes from "./types/CreateWaveDropsTypes";
import CreateWaveTermsOfService from "./terms/CreateWaveTermsOfService";
export default function CreateWaveDrops(t0) {
  const $ = _c(33);
  const {
    waveType,
    drops,
    errors,
    setDrops
  } = t0;
  let t1;
  if ($[0] !== drops || $[1] !== setDrops) {
    t1 = e => {
      const noOfApplicationsAllowedPerParticipant = parseInt(e.target.value);
      const isValid = !isNaN(noOfApplicationsAllowedPerParticipant) && noOfApplicationsAllowedPerParticipant > 0;
      setDrops({
        ...drops,
        noOfApplicationsAllowedPerParticipant: isValid ? noOfApplicationsAllowedPerParticipant : null
      });
    };
    $[0] = drops;
    $[1] = setDrops;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onNoOfApplicationsAllowedPerParticipantChange = t1;
  let t2;
  if ($[3] !== drops || $[4] !== setDrops) {
    t2 = types => {
      setDrops({
        ...drops,
        requiredTypes: types
      });
    };
    $[3] = drops;
    $[4] = setDrops;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onRequiredTypeChange = t2;
  let t3;
  if ($[6] !== drops || $[7] !== setDrops) {
    t3 = requiredMetadata => {
      setDrops({
        ...drops,
        requiredMetadata
      });
    };
    $[6] = drops;
    $[7] = setDrops;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onRequiredMetadataChange = t3;
  const isNotChatType = waveType !== ApiWaveType.Chat;
  let t4;
  if ($[9] !== drops || $[10] !== setDrops) {
    t4 = terms => {
      setDrops({
        ...drops,
        terms,
        signatureRequired: !!terms
      });
    };
    $[9] = drops;
    $[10] = setDrops;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onTermsChange = t4;
  let t5;
  if ($[12] !== drops.requiredTypes || $[13] !== onRequiredTypeChange) {
    t5 = <CreateWaveDropsTypes requiredTypes={drops.requiredTypes} onRequiredTypeChange={onRequiredTypeChange} />;
    $[12] = drops.requiredTypes;
    $[13] = onRequiredTypeChange;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== drops.requiredMetadata || $[16] !== errors || $[17] !== onRequiredMetadataChange) {
    t6 = <div className="tw-border-t tw-border-solid tw-border-iron-700 tw-border-x-0 tw-border-b-0 tw-pt-6"><CreateWaveDropsMetadata requiredMetadata={drops.requiredMetadata} errors={errors} onRequiredMetadataChange={onRequiredMetadataChange} /></div>;
    $[15] = drops.requiredMetadata;
    $[16] = errors;
    $[17] = onRequiredMetadataChange;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== drops.noOfApplicationsAllowedPerParticipant || $[20] !== isNotChatType || $[21] !== onNoOfApplicationsAllowedPerParticipantChange) {
    t7 = isNotChatType && <div className="tw-border-t tw-border-solid tw-border-iron-700 tw-border-x-0 tw-border-b-0 tw-pt-6 tw-flex tw-flex-col tw-gap-y-2"><div className="tw-group tw-w-full tw-relative"><input type="text" value={drops.noOfApplicationsAllowedPerParticipant !== null ? drops.noOfApplicationsAllowedPerParticipant.toString() : ""} onChange={onNoOfApplicationsAllowedPerParticipantChange} id="no-of-applications-allowed-per-participant" autoComplete="off" className={`${drops.noOfApplicationsAllowedPerParticipant ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"} tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400  tw-form-input tw-block tw-px-4 tw-py-4 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-border-iron-600 tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`} placeholder=" " /><label htmlFor="no-of-applications-allowed-per-participant" className={"peer-focus:tw-text-primary-400 tw-text-iron-500  tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2  peer-placeholder-shown:tw-scale-100 \n              peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>Maximum number of simultaneous submissions per participant</label></div><p className="tw-text-sm tw-text-iron-400 tw-font-medium">Optional. Unlimited if left blank.</p></div>;
    $[19] = drops.noOfApplicationsAllowedPerParticipant;
    $[20] = isNotChatType;
    $[21] = onNoOfApplicationsAllowedPerParticipantChange;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== drops.terms || $[24] !== isNotChatType || $[25] !== onTermsChange || $[26] !== waveType) {
    t8 = isNotChatType && <div className="tw-border-t tw-border-solid tw-border-iron-700 tw-border-x-0 tw-border-b-0 tw-pt-6"><CreateWaveTermsOfService waveType={waveType} terms={drops.terms} setTerms={onTermsChange} /></div>;
    $[23] = drops.terms;
    $[24] = isNotChatType;
    $[25] = onTermsChange;
    $[26] = waveType;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-gap-y-8">{t5}{t6}{t7}{t8}</div>;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}